<rid-map-label [name]="comp().province.name" [dots]="locationDots()" [state]="labelState()" [pulsing]="hasWorkToday()" />
